import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { TableProps } from './types.js';

/** `<Table>` component. */
export const Table = ({ children, className, ...props }: TableProps): ReactElement => (
  <table
    className={twMerge(
      'rounded bg-base-200 text-sm text-muted',
      '[&_th]:border-b [&_th]:border-base-50 [&_th]:px-12 [&_th]:py-8',
      '[&_td:last-child]:border-0 [&_td]:border-r [&_td]:border-base-50 [&_td]:p-12',
      className
    )}
    {...props}
  >
    {children}
  </table>
);
